import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormalizeCommentModule } from './formalize-comment/formalize-comment.module';
import { BulkFormalizeModule } from './bulk-formalize/bulk-formalize.module';
import { VoiceInputModule } from './voice-input/voice-input.module';
import { AiActivitiesModule } from './ai-activities/ai-activities.module';

@NgModule({
  imports: [
    CommonModule,
    FormalizeCommentModule,
    BulkFormalizeModule,
    VoiceInputModule,
    AiActivitiesModule
  ],
  exports: [
    FormalizeCommentModule,
    BulkFormalizeModule,
    VoiceInputModule,
    AiActivitiesModule
  ]
})
export class AiAssistantModule { }
